

































import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'ContentSpecialLib'
})
export default class extends Vue {
  handleAdd() {
    const child: any = this.$refs.child
    child.handleAdd()
  }
  handleExcel() {
    const child: any = this.$refs.child
    child.handleExcel()
  }
}
